import { SourceType } from 'api-models'
import { Compass03 as RiCompass4Line } from 'components/icons'
import { CornerDownRight as RiCornerDownRightLine, Flag01 as RiFlagLine, FolderShield as RiFolderShield2Line, Tag01 as RiPriceTag3Line } from 'components/icons'
import { RuleFormType } from '../../../rule-form/types'

export const Actions = (props: { rule: RuleFormType, titleClass?: string }) => {
	const { rule, titleClass } = props
	const isRangeFocus = rule.trigger.focus === SourceType.RANGE

	return (
		<div className="text-sm">
			<span className={`text-t-gray-checkout font-medium ${titleClass}`}>
				THEN
			</span>
			<div className={`flex flex-col gap-1  mt-1 ${!titleClass && 'pl-2'}`}>
				<ClickStatus resolve_status={rule.resolve_status} />
				{rule.resolve_labels.enabled &&
					rule.resolve_labels.labels &&
					rule.resolve_labels.labels.length > 0 && (
						<ClickLabels labels={rule.resolve_labels.labels} />
					)}
				{rule.block && <FullBlocking isRangeFocus={isRangeFocus} />}
				{rule.block === null && (
					<>
						{rule.temp_ip_exclusion && (
							<IpExclusion isRangeFocus={isRangeFocus} />
						)}
						{rule.audience_exclusion && <AudienceExclusion />}
					</>
				)}
			</div>
		</div>
	)
}

const ClickStatus = (props: {
	resolve_status: RuleFormType['resolve_status']
}) => {
	const { resolve_status } = props

	const color =
		resolve_status === 'BAD'
			? 'text-red-500'
			: resolve_status === 'SUSPICIOUS'
			? 'text-amber-500'
			: 'text-green-500'

	return (
		<div className="flex items-center text-t-checkbox-unactive">
			<RiFlagLine className={`h-4 w-4 mr-1 ${color}`} /> Set click status as
			<strong className="font-bold ml-0.5">{resolve_status}</strong>
		</div>
	)
}

const ClickLabels = (props: { labels: string[] }) => {
	const { labels } = props

	return (
		<div className="flex items-center text-t-secondary">
			<RiPriceTag3Line className="h-3 w-3 text-[#0B34CB] mr-1" /> Label click as
			<strong className="font-bold ml-0.5">{labels.join(', ')}</strong>
		</div>
	)
}

const FullBlocking = (props: { isRangeFocus: boolean }) => {
	const { isRangeFocus } = props

	return (
		<>
			<div className="flex items-center text-t-secondary">
				<RiFolderShield2Line className="h-3 w-3 text-red-600 mr-1" />{' '}
				<strong className="font-bold mr-0.5">Blacklist</strong> the clicking
				source
			</div>
			<div className="flex items-center text-t-secondary pl-0.5">
				<RiCornerDownRightLine className="h-3 w-3 text-t-secondary mr-1" />{' '}
				Exclude IP {isRangeFocus ? 'range' : 'address'} on targeted campaign
			</div>
			<div className="flex items-center text-t-secondary pl-0.5">
				<RiCornerDownRightLine className="h-3 w-3 text-t-secondary mr-1" /> Add
				visitor to excluded audience
			</div>
		</>
	)
}

const IpExclusion = (props: { isRangeFocus: boolean }) => {
	const { isRangeFocus } = props

	return (
		<div className="flex items-center text-t-secondary">
			<RiCompass4Line className="h-3 w-3 text-red-600 mr-1" /> Exclude IP{' '}
			{isRangeFocus ? 'range' : 'address'} on targeted campaign
		</div>
	)
}

const AudienceExclusion = () => {
	return (
		<div className="flex items-center text-t-secondary">
			<RiCompass4Line className="h-3 w-3 text-purple-600 mr-1" /> Add visitor to
			excluded audience
		</div>
	)
}
